import { createContext, useContext, useState } from "react";
// import logger from '../../utils/logger.js'

const ToggleContext = createContext();


export const ToggleProvider = ({ children }) => {
  const [isActive, setIsActive] = useState(false)
  const [callerElementId, setCallerElementId] = useState(null)

  const toggleClose = () => {
    setIsActive((prev) => false)
  }


  const toggleBTN = (e) => {
    // logger.info('e:', e)
    setCallerElementId(e)
    setIsActive(!isActive)
  }

  //console.log('isActive context: ', isActive)

  return (
    <ToggleContext.Provider value={{ isActive, toggleClose, toggleBTN,callerElementId }}>
      {children}
    </ToggleContext.Provider>
  );
};


export const useToggle = () => useContext(ToggleContext)
